import Fonts from "baseStyles/enums/fonts";
import { Colors } from "baseStyles/enums/colors";
import React, { useEffect, useState } from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import MergeStudentStyles from "./styles";
import { FlexProps } from "../../schoolUiComponents/basic/Box/FlexBox/types";
import { SuccessPopup } from "./successPopup";
import { NewChild } from "./newChild";
import { ReplaceChild } from "./replaceChild";
import { interactedAddreplaceStudentProfileScreenEvent, viewedAddreplaceStudentProfileScreenEvent } from "../events";
import StringUtility from "utility/string";
import { REFERRER_PAGE_MAP } from "utility/referrer";

export const MAX_LINKED_CHILD_LIMIT = 3;

export interface IChild {
    show_gamification_avatar?: boolean;
    id: string;
    first_name: string;
    last_name: string;
    avatar: number;
    grade: string;
    grade_code?: string;
}

export interface IReferralData { 
    referrerPage: string; 
    invitationSource: string
};

export const MergeStudent = () => {
    const [replaceChild, setReplaceChild] = useState(null);
    // @ts-ignore
    const newChild = window.ADD_OR_REPLACE_DATA.new_student;
     // @ts-ignore
    const existingChild = window.ADD_OR_REPLACE_DATA.existing_students;
     // @ts-ignore
    const parentInfo = window.ADD_OR_REPLACE_DATA.parent;
     // @ts-ignore
    const showScreen = window.ADD_OR_REPLACE_DATA.show_screen;
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [optionSelected, setOptionSelected] = useState("");
    const [referralData, setReferralData] = useState<IReferralData>({ referrerPage: "", invitationSource: "" });
    const showReplaceChild = showScreen.includes("merge-child");
    const showNewChild = ((existingChild.length !== MAX_LINKED_CHILD_LIMIT) && (showScreen.includes("add-child")));

    const styles = MergeStudentStyles();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const referrerPage = REFERRER_PAGE_MAP[urlParams.get("referrer_code")] || "default";
        const invitationSource = urlParams.get("referral_type") || "";
        setReferralData({ referrerPage, invitationSource });
        setReplaceChild(getReplaceChild());
        let optionsViewed = [];
        showNewChild && optionsViewed.push("Link as new profile");
        showReplaceChild && optionsViewed.push("Replace profile");
        viewedAddreplaceStudentProfileScreenEvent({ grade: newChild.grade_code, linkedStudentCount: existingChild.length.toString(), optionsViewed, referrerPage, invitationSource, teacherSignupDate: window.ADD_OR_REPLACE_DATA?.new_student?.teacherSignupDate ? window.ADD_OR_REPLACE_DATA?.new_student?.teacherSignupDate : "" });
    }, [])

    const getReplaceChild = () => {
        if (existingChild.length == 1) {
            return existingChild[0];
        }
        return null
    }

    const selectExistingChild = (child: any) => {
        setReplaceChild(child);
    }

    const goToDshboard = () => {
        interactedAddreplaceStudentProfileScreenEvent({ clickedOn: "Skip to dashboard", linkedStudentCount: existingChild.length.toString(), grade: newChild.grade_code, ...referralData })
        window.location.href = "/";
    }

    const popupCloseCallback = () => {
        setShowSuccessPopup(false)
    }

    if(!newChild) {
        window.location.href = "/";
        return;
    }

    return (
        <FlexBox dataTestId="merge-student" fullWidth backgroundColor={Colors.WHITE} minHeight={`${window.innerHeight - 61}px`} column>
            <FlexBox padding={"32px 24px 24px 24px"} gap={32} {...styles.mainBox} column fullWidth>
                <FlexBox fullWidth gap={8} column>
                    <Text.SMALL color={Colors.CONTENT_TEXT_TERTIARY} fullWidth center>Logged in with {parentInfo.email}</Text.SMALL>
                    {showNewChild && showReplaceChild && <Text.H2 color={Colors.BLACK} lines={3} fullWidth center emphasis>Link {StringUtility.formatFullName(newChild.first_name, newChild.last_name)} to your parent account</Text.H2>}
                    {existingChild.length == MAX_LINKED_CHILD_LIMIT ? <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY} fullWidth center lines={2}>You can only link up to {MAX_LINKED_CHILD_LIMIT} student profiles per account. Create a new account or replace an existing profile.</Text.SMALL> : null}
                </FlexBox>
                <FlexBox flex={1} gap={24} alignItems={FlexProps.AlignItems.FLEX_START} {...styles.childBox}>
                    { showNewChild ? 
                        <NewChild newChild={newChild} setShowSuccessPopup={setShowSuccessPopup}  showReplaceChild={showReplaceChild} existingChild= {existingChild} setOptionSelected= {setOptionSelected} referralData = {referralData}/> 
                        : null }
                    { (showNewChild && showReplaceChild) ? <FlexBox { ...styles.orBox }>
                        <Text.H4 color={Colors.CONTENT_TEXT_TERTIARY} fontWeight={Fonts.Weight.W400}>or</Text.H4>
                    </FlexBox> : null }
                    { showReplaceChild ? <ReplaceChild existingChild= {existingChild} newChild={newChild} selectExistingChild={selectExistingChild} replaceChild={replaceChild} setShowSuccessPopup={setShowSuccessPopup} parentInfo={parentInfo} showNewChild={showNewChild} showPrimary = {showReplaceChild && !showNewChild } setOptionSelected= {setOptionSelected} referralData = {referralData} /> : null }
                </FlexBox>
                {existingChild.length === MAX_LINKED_CHILD_LIMIT ? <FlexBox onClick = {goToDshboard}>
                <Text.H4 color={Colors.PURE_PURPLE}>Skip to dashboard</Text.H4>
            </FlexBox> : null }
            </FlexBox>
            {showSuccessPopup ? <SuccessPopup child={newChild}  popupCloseCallback = {popupCloseCallback} existingChild={existingChild} optionSelected = {optionSelected} referralData= {referralData} /> : null}
        </FlexBox>
    )
}